import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-subsidiary-memorandum',
  templateUrl: './subsidiary-memorandum.component.html',
  styleUrls: ['./subsidiary-memorandum.component.css']
})
export class SubsidiaryMemorandumComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
